import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c146bf12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }

import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const router = useRouter();

function addSurvey() {
    router.push({
        name: 'Survey',
        params: { id: 'new' }
    });
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_btn, {
      color: "primary",
      onClick: addSurvey,
      "prepend-icon": "mdi-plus"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Agregar nueva encuesta ")
      ]),
      _: 1
    })
  ]))
}
}

})